import React, { Fragment, useEffect, useState, useContext } from "react";
import localization from "../../../assets/localization/localization";
import Layout from "../../../components/sales/layout/layout";
import DivLayout from "../../../components/sales/divLayout/divLayout";
import DocumentView from "../../../components/sales/downloadDocView/documentView";
import ModalPop from "components/sales/modal/modal";
import FileUpload from "components/sales/fileUpload/fileUpload";
import { Button } from "react-bootstrap";
import Images from "assets/images/imageData";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";

const RcTransferView = ({
  match,
  getAllRcTransfer,
  rcTransferListing = [],
  updateStatusRcTransfer,
  updateRcStatus = [],
  documentUploadUrlPublic,
  documentUrlDataPublic,
}) => {
  const inputs = {
    lead_id: match?.params?.lead_id,
    status: "",
    invoice_link: "",
  };
  const [formData, setFormData] = useState(inputs);
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [approveModal, setApproveModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const { baseUrl } = useContext(BaseUrl);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getAllRcTransfer(1, match?.params?.lead_id, null, null);
      setIsLoading(false);
    })();
  }, []);

  const handleHeadResponse = async () => {
    // console.log("status check:", formData);
    // return false;
    setIsLoading(true);
    const res = await updateStatusRcTransfer(formData);
    if (res.status) {
      setIsModal(true);
    }
    setIsLoading(false);
  };

  const handleModalHide = () => setIsModal(false);

  const handleUpdateStatusButton = async () => {
    setIsLoading(true);
    setApproveModal(true);
    setIsLoading(false);
  };

  const handleApproveModalHide = () => setApproveModal(false);
  const handleRejectModalHide = () => setRejectModal(false);

  const headerBtns = () => {
    return (
      <Fragment>
        <>
          <Button
            onClick={() => handleUpdateStatusButton()}
            className="btn btn-success"
          >
            {"Update Status"}
          </Button>
        </>
      </Fragment>
    );
  };

  return (
    <>
      <Layout
        title={"Detailed View"}
        isLoading={isLoading}
        isGoback={true}
        Buttons={headerBtns}
      >
        {/* {console.log(rcTransferListing?.data?.resultSets)} */}
        <div className="panel-card card-details" width="100%">
          <div className="panel-heading">{localization.detailView}</div>
          <div className="panel-body">
            <div className="details-listing detail_alignment">
              <DivLayout
                heading={"Vehicle Number"}
                data={rcTransferListing?.data?.resultSets[0]?.vehicle_number}
              />
              <DivLayout
                heading={"Appointment Date"}
                data={rcTransferListing?.data?.resultSets[0]?.appointment_date}
              />
              <DivLayout
                heading={"Lead Status"}
                data={rcTransferListing?.data?.resultSets[0]?.lead_status}
              />
              <DivLayout
                heading={"User ID"}
                data={rcTransferListing?.data?.resultSets[0]?.user_id}
              />
              <DivLayout
                heading={"User Type"}
                data={rcTransferListing?.data?.resultSets[0]?.type_of_user}
              />
              <DivLayout
                heading={"Vehicle Registration City"}
                data={
                  rcTransferListing?.data?.resultSets[0]
                    ?.vehicle_registration_city
                }
              />
              <DivLayout
                heading={"Owner Transfer City"}
                data={
                  rcTransferListing?.data?.resultSets[0]?.owner_transfer_city
                }
              />
              <DocumentView
                attachment={
                  rcTransferListing?.data?.resultSets[0]?.invoice_link
                }
                title={"Invoice"}
              />
            </div>
          </div>
        </div>

        <div className="panel-card card-details" style={{ width: "100%" }}>
          <div className="panel-heading">Documents</div>
          <div className="panel-body">
            <div className="details-listing detail_alignment">
              {rcTransferListing?.data?.resultSets[0]?.documents?.map(
                (document) => (
                  <div className="col-md-6">
                    <DocumentView
                      attachment={document?.url}
                      title={document?.label}
                    />
                  </div>
                )
              )}
            </div>
          </div>
        </div>

        <div className="panel-card card-details" width="100%">
          <div className="panel-heading">{"Pickup Address"}</div>
          <div className="panel-body">
            <div className="details-listing detail_alignment">
              <DivLayout
                heading={"City"}
                data={
                  rcTransferListing?.data?.resultSets[0]?.pickup_address["city"]
                }
              />
              <DivLayout
                heading={"State"}
                data={
                  rcTransferListing?.data?.resultSets[0]?.pickup_address[
                    "state"
                  ]
                }
              />
              <DivLayout
                heading={"Address 1"}
                data={
                  rcTransferListing?.data?.resultSets[0]?.pickup_address[
                    "address1"
                  ]
                }
              />
              <DivLayout
                heading={"Address 2"}
                data={
                  rcTransferListing?.data?.resultSets[0]?.pickup_address[
                    "address2"
                  ]
                }
              />
              <DivLayout
                heading={"Postal Code"}
                data={
                  rcTransferListing?.data?.resultSets[0]?.pickup_address[
                    "postalCode"
                  ]
                }
              />
              <DivLayout
                heading={"Latitude"}
                data={
                  rcTransferListing?.data?.resultSets[0]?.pickup_address
                    ?.coordinates?.lat
                }
              />
              <DivLayout
                heading={"Longitude"}
                data={
                  rcTransferListing?.data?.resultSets[0]?.pickup_address
                    ?.coordinates?.lng
                }
              />
            </div>
          </div>
        </div>

        <div className="panel-card card-details" width="100%">
          <div className="panel-heading">{"Meta Information"}</div>
          <div className="panel-body">
            <div className="details-listing detail_alignment">
              <DivLayout
                heading={"Name"}
                data={rcTransferListing?.data?.resultSets[0]?.meta_info["name"]}
              />
              <DivLayout
                heading={"Role"}
                data={
                  rcTransferListing.response?.data?.data?.results[0]?.meta_info[
                    "role"
                  ]
                }
              />
              <DivLayout
                heading={"Email"}
                data={
                  rcTransferListing.response?.data?.data?.results[0]?.meta_info[
                    "email"
                  ]
                }
              />
              <DivLayout
                heading={"Device ID"}
                data={
                  rcTransferListing.response?.data?.data?.results[0]?.meta_info[
                    "device_id"
                  ]
                }
              />
              <DivLayout
                heading={"Pollution"}
                data={
                  rcTransferListing.response?.data?.data?.results[0]?.meta_info[
                    "pollution"
                  ]
                }
              />
              <DivLayout
                heading={"Brand Name"}
                data={
                  rcTransferListing.response?.data?.data?.results[0]?.meta_info[
                    "brand_name"
                  ]
                }
              />
              <DivLayout
                heading={"Model Name"}
                data={
                  rcTransferListing?.data?.resultSets[0]?.meta_info[
                    "model_name"
                  ]
                }
              />
              <DivLayout
                heading={"Phone Number"}
                data={
                  rcTransferListing?.data?.resultSets[0]?.meta_info[
                    "phone_number"
                  ]
                }
              />
              <DivLayout
                heading={"Reg. Authority"}
                data={
                  rcTransferListing?.data?.resultSets[0]?.meta_info[
                    "reg_authority"
                  ]
                }
              />
              <DivLayout
                heading={"Insurance Date"}
                data={
                  rcTransferListing?.data?.resultSets[0]?.meta_info[
                    "insurance_date"
                  ]
                }
              />
              <DocumentView
                attachment={
                  rcTransferListing?.data?.resultSets[0]?.meta_info[
                    "brand_icon"
                  ]
                }
                title={"Brand Icon"}
              />
            </div>
          </div>
        </div>

        <ModalPop
          title={"Are you sure to update the status?"}
          show={approveModal}
          handleModalHide={handleApproveModalHide}
          keyboard
          backdrop
        >
          <div className="row">
            <div className="col-md-9">
              <DropDownInput
                data={[
                  { id: "LEAD CAPTURED", name: "LEAD CAPTURED" },
                  { id: "QC DONE", name: "QC DONE" },
                  { id: "PICKUP CONFIRMED", name: "PICKUP CONFIRMED" },
                  { id: "LEAD RESCHEDULED", name: "LEAD RESCHEDULED" },
                  { id: "CUSTOMER NOT RESPONDING", name: "CUSTOMER NOT RESPONDING" },
                  { id: "AGENT ASSIGNED", name: "AGENT ASSIGNED" },
                  { id: "TODAY'S APPOINTMENT", name: "TODAY'S APPOINTMENT" },
                  { id: "DOCUMENTS COLLECTED", name: "DOCUMENTS COLLECTED" },
                  { id: "PHYSICAL VALIDATION", name: "PHYSICAL VALIDATION" },
                  { id: "RTO READY", name: "RTO READY" },
                  { id: "RTO SUBMITTED", name: "RTO SUBMITTED" },
                  { id: "PARTY PESHI", name: "PARTY PESHI" },
                  { id: "TRANSFER COMPLETED", name: "TRANSFER COMPLETED" },
                  { id: "DEFERRED", name: "DEFERRED" },
                  { id: "TERMINATED", name: "TERMINATED" },
                ]}
                label={localization.type}
                required
                errorMsg={localization.requiredName}
                getIdValue={(val) => {
                  setFormData({
                    ...formData,
                    status: val.id,
                  });
                }}
                isStarRequired={true}
              />
            </div>

            {formData?.status === "RTO SUBMITTED" && (
              <div className="col-md-3 mb-5">
                <FileUpload
                  id="addAttachment"
                  accept=".pdf,.png,.jpg,.jpeg,.doc"
                  documentUploadUrl={documentUploadUrlPublic}
                  documentUrlData={documentUrlDataPublic}
                  onChange={(val) =>
                    setFormData({ ...formData, invoice_link: val })
                  }
                  showFileName={false}
                >
                  <span className="btn btn-transparent">
                    {"Invoice Upload"}
                  </span>
                </FileUpload>
              </div>
            )}
          </div>
          <br />
          <div className="mt-5">
            <Button
              onClick={() => handleHeadResponse(formData)}
              className="btn btn-primary mb-4"
            >
              {localization.update}
            </Button>
          </div>
        </ModalPop>

        <ModalPop
          title={localization.conf}
          show={rejectModal}
          handleModalHide={handleRejectModalHide}
          keyboard
          backdrop
        >
          <div className="text-center">
            <div className="success">
              <img src={Images?.tick} alt="" />
            </div>
            <h5>{"Are you sure to reject?"}</h5>
            <div style={{ display: "flex", justifyContent: "space-evenly" }}>
              <Button
                onClick={handleRejectModalHide}
                className="btn btn-primary mb-4"
              >
                {localization.no}
              </Button>
              <Button
                onClick={() => handleHeadResponse("REOPENED")}
                className="btn btn-primary mb-4"
              >
                {localization.yes}
              </Button>
            </div>
          </div>
        </ModalPop>

        <ModalPop
          title={localization.conf}
          show={isModal}
          handleModalHide={handleModalHide}
          keyboard
          backdrop
        >
          <div className="text-center">
            <div className="success">
              <img src={Images?.tick} alt="" />
            </div>
            <h5>{"Status Updated Successfull"}</h5>
            <Link
              to={`${baseUrl}/rc-transfer`}
              className="btn btn-primary mb-4"
            >
              {"Back to list"} <img src={Images?.ArrowRight} alt="" />
            </Link>
          </div>
        </ModalPop>
      </Layout>
    </>
  );
};

export default RcTransferView;
